import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { formatNumber } from '../../../Utils/Money';
import moment from 'moment';

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const DetailedSurchargesTable = ({ title, reactTableData, ReactTableActions }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        withSearchEngine,
        placeholder: 'Buscar Paciente',
        manualPageSize: [5, 10]
    };

    const columnsData = [
        {
            Header: 'Primer Apellido',
            accessor: 'apellido1',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Segundo Apellido',
            accessor: 'apellido2',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Primer Nombre',
            accessor: 'primerNombre',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Segundo Nombre',
            accessor: 'segundoNombre',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Número de Documento',
            accessor: 'num_documento',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Tipo de Documento',
            accessor: 'tip_documento',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Fecha de Atención',
            accessor: 'fecha_admision',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {moment(row.value).format('DD-MM-YYYY')}
                    </label>
                </div>
            )
        },
        {
            Header: 'Codigo de Validación',
            accessor: 'codigo_validacion',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Codigo de Autorización',
            accessor: 'codigo_autorizacion',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Servicio',
            accessor: 'servicio',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Cantidad',
            accessor: 'cantidad',
            Cell: row => (
                <div style={{ width: '250px' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        {
            Header: 'Costo',
            accessor: 'costo',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        $ {formatNumber(row.value)}
                    </label>
                </div>
            )
        },
        {
            Header: 'Copago',
            accessor: 'copago',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        $ {formatNumber(row.value)}
                    </label>
                </div>
            )
        },
        {
            Header: 'Neto',
            accessor: 'neto',
            Cell: row => (
                <div style={{ width: '120px' }}>
                    <label>
                        $ {formatNumber(row.value)}
                    </label>
                </div>
            )
        }
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

DetailedSurchargesTable.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default DetailedSurchargesTable;
